module.exports = __webpack_public_path__ + "img/LV40003194988.521665d5.png";